var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from "react";
import classNames from "classnames";
import { useDevice } from "../../utils/hooks/useDevice";
import { LazyImage } from "../LazyImage";
import { Drawer } from "../Drawer";
import HeaderItem from "./HeaderItem";
import HeaderMenuItem from "./HeaderMenuItem";
import HeaderMenuItemDivider from "./HeaderMenuItemDivider";
import HeaderLanguageSelector from "./HeaderLanguageSelector";
// styles
import "./header.scss";
// use the optional prop interface to define the default props
const defaultProps = {
    "data-testid": "tecma-header",
};
const Header = (_a) => {
    var { className, logo, desktopHeaderContent, mobileHeaderContent, mobileDrawerContent, mobileDrawerTitle, logoWrapper: LogoWrapper = "" } = _a, rest = __rest(_a, ["className", "logo", "desktopHeaderContent", "mobileHeaderContent", "mobileDrawerContent", "mobileDrawerTitle", "logoWrapper"]);
    const classList = classNames("tecma-header", className);
    const device = useDevice();
    const [isDrawerOpen, setIsDrawerOpen] = useState(false);
    const toggleDrawer = () => setIsDrawerOpen(!isDrawerOpen);
    return (_jsxs("nav", Object.assign({ className: classList }, rest, { children: [_jsx(LogoWrapper, { children: _jsx(LazyImage.Image, { className: "tecma-header-logo", src: logo, errorElement: _jsx(_Fragment, { children: " " }), loadingElement: _jsx(_Fragment, { children: " " }) }) }), _jsxs("div", { className: "tecma-header-utility-menu", children: [device.type === "desktop" ? desktopHeaderContent : mobileHeaderContent, device.type !== "desktop" && !!mobileDrawerContent && (_jsxs(_Fragment, { children: [_jsx(HeaderItem, { className: "toggle-drawer-button", iconName: "menu", onClick: toggleDrawer }), _jsxs(Drawer, { open: isDrawerOpen, onClose: toggleDrawer, anchor: "right", children: [_jsx(Drawer.Header, { onClose: toggleDrawer, label: mobileDrawerTitle }), mobileDrawerContent] })] }))] })] })));
};
Header.defaultProps = defaultProps;
const HeaderSpace = Object.assign(Header, {
    Item: HeaderItem,
    MenuItem: HeaderMenuItem,
    Divider: HeaderMenuItemDivider,
    LanguageSelector: HeaderLanguageSelector,
});
export default HeaderSpace;
